import { useSelector, useDispatch } from 'react-redux';
import FJMobileGenerateStatus from './FJMobileGenerateStatus';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useCallback } from 'react';
const FJMobileGenerateStatusContainer = () => {
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const progress = useSelector(state => state.common.progress);
    const currentQueue = useSelector(state => state.common.currentQueue);
    const queueNumber = useSelector(state => state.common.queueNumber);
    const onCancel = useCallback(() => {
        dispatch(FJActionCommon.cancelTaskAction());
    }, [dispatch]);
    return (
        <FJMobileGenerateStatus
            taskStatus={taskStatus}
            onCancel={onCancel}
            progress={progress}
            currentQueue={currentQueue}
            queueNumber={queueNumber}
        />
    );
};
export default FJMobileGenerateStatusContainer;
